import {
  msgBadRequest,
  msgMaintenanceMode,
  msgNetworkError,
  msgNoPermission,
  msgServiceError,
  msgServiceNotFound,
  msgUnauthorized,
} from "./constants";

export const parseErrorHelper = (e) => {
  console.log(e);
  if (e.message === "Network Error") {
    if (navigator.onLine) {
      // return new Promise((resolve) => {
      //     fetch("https://www.google.com/", { mode: "no-cors" })
      //     .then(() => resolve(i18n.t("MAINTENANCE_MODE")))
      //     .catch(() => resolve(i18n.t("NETWORK_ERROR")));
      // })
      return msgMaintenanceMode;
    } else {
      return msgNetworkError;
    }
  } else {
    if (e.response) {
      if (e.response.status === 401) {
        return msgUnauthorized;
      } else if (e.response.status === 403) {
        return msgNoPermission;
      } else if (e.response.status === 404) {
        return msgServiceNotFound;
      } else if (e.response.status === 405) {
        return msgBadRequest;
      } else if (e.response.status === 500) {
        return msgServiceError;
      } else {
        const message = e.response?.data?.message;
        if (message && message !== "Bad Request") return message;
        return e.response?.data?.message || msgBadRequest;
      }
    } else {
      return msgServiceError;
    }
  }
};

export const getUserNameHelper = (userData) => {
  if (!userData) return "";
  let userName =
    `${userData.firstname || ""} ` + `${userData.lastname1 || ""} ` + `${userData.lastname2 || ""}`;
  if (!userName || !userName.trim()) userName = userData.email;
  return userName ? userName.trim() : "-";
};
